import classNames from "classnames";
import { Link } from "react-router-dom";

type LinkProps = {
	link: {
		label?: string;
		url: string;
		type?: "button" | "email" | "avatar";
		img?: string;
	};
	isExternal?: boolean;
	className?: string;
	children?: React.ReactNode;
};

const CustomLink = ({
	isExternal = false,
	className,
	children = undefined,
	link,
	...rest
}: LinkProps) => {
	return isExternal ? (
		<a
			href={link.url}
			aria-label={children ? link.label : undefined}
			target="_blank"
			rel="noopener noreferrer"
			className={classNames("link link--external", className)}
			{...rest}>
			{link.img ? (
				<img src={link.img} alt={link.label} className="link__image" />
			) : (
				children || link.label
			)}
		</a>
	) : (
		<Link
			to={link?.type === "email" ? `mailto:${link.url}` : link.url}
			aria-label={children ? link.label : undefined}
			className={classNames(
				"link link--internal",
				{ "link--email": link?.type === "email" },
				className,
			)}
			{...rest}>
			{link.img ? (
				<img src={link.img} alt={link.label} className="link__image" />
			) : (
				children || link.label
			)}
		</Link>
	);
};

export default CustomLink;
